import { render, staticRenderFns } from "./contacted.vue?vue&type=template&id=905f574c&scoped=true&"
import script from "./contacted.vue?vue&type=script&lang=js&"
export * from "./contacted.vue?vue&type=script&lang=js&"
import style0 from "./contacted.vue?vue&type=style&index=0&id=905f574c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905f574c",
  null
  
)

export default component.exports